import { getCustomerFullName, getCustomerPrimaryEmail, getCustomerPrimaryPhone } from '@/utils/customerHelpers'

/**
 * Prefer frozen customer_snapshot on completed sales; fall back to live customer relation.
 *
 * @param {{ customer_snapshot?: object|null, customer?: object|null }} sale
 * @returns {{ name: string|null, email: string|null, phone: string|null }|null}
 */
export function resolveSaleCustomerDisplay (sale) {
  const snapshot = sale?.customer_snapshot
  if (snapshot && typeof snapshot === 'object') {
    const name = String(snapshot.name || '').trim()
    const email = String(snapshot.email || '').trim()
    const phone = String(snapshot.phone || '').trim()
    if (name || email || phone) {
      return {
        name: name || null,
        email: email || null,
        phone: phone || null
      }
    }
  }

  const customer = sale?.customer
  if (!customer) {
    return null
  }

  return {
    name: getCustomerFullName(customer) || null,
    email: getCustomerPrimaryEmail(customer) || null,
    phone: getCustomerPrimaryPhone(customer) || null
  }
}

export function saleHasCustomerDisplay (sale) {
  return resolveSaleCustomerDisplay(sale) !== null
}

/**
 * Whether the sale is linked to a customer record (not a walk-in sale).
 *
 * @param {{ customer_id?: number|null, customer?: object|null }} sale
 */
export function saleHasAttachedCustomer (sale) {
  if (sale?.customer_id != null && sale.customer_id !== '') {
    return true
  }
  return !!(sale?.customer && typeof sale.customer === 'object' && sale.customer.id != null)
}

/**
 * Single-line customer label for receipts (thermal, print, preview).
 *
 * @param {{ customer_id?: number|null, customer?: object|null, customer_snapshot?: object|null }} sale
 * @param {string} [walkInLabel]
 */
export function resolveSaleCustomerReceiptLabel (sale, walkInLabel = 'Walk-In') {
  if (!saleHasAttachedCustomer(sale)) {
    return walkInLabel
  }
  const snapshotName = String(sale?.customer_snapshot?.name || '').trim()
  if (snapshotName) {
    return snapshotName
  }
  const fromRelation = sale?.customer ? getCustomerFullName(sale.customer) : ''
  const name = String(fromRelation || resolveSaleCustomerDisplay(sale)?.name || '').trim()
  return name || walkInLabel
}
